module.exports = __webpack_public_path__ + "static/img/help_02class_04.7d5840b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_02class_04.png
// module id = 685
// module chunks = 140